import { createSlice } from '@reduxjs/toolkit';
import { SystemSetting } from '../util/RoleUtil';
import { isArray, isEqual, uniqBy } from 'lodash';

interface URLPath {
  key: string;
  label: string;
  reset?: boolean;
}

export const organizationSlice = createSlice({
  name: 'organizationManagement',
  initialState: {
    organizationList: [],
    parentDetails: [],
    organizationData: {},
    loggedInOrganization: null,
    urlPaths: [] as URLPath[],
    organizationSetting: {} as SystemSetting,
    organizationPermission: [],
    organizationDetails: {} as any
  },
  reducers: {
    setOrganizationList: (state, action) => {
      state.organizationList = action.payload;
    },
    setParentDetails: (state, action) => {
      state.parentDetails = action.payload;
    },
    setIndividualOrganizationData: (state, action) => {
      state.organizationData = action.payload;
    },
    setLoggedInOrganization: (state, action) => {
      state.loggedInOrganization = action.payload;
    },
    setURLPaths: (state, action) => { //Depreciated. Use setBreadcrump
      state.urlPaths = action.payload;
    },
    setBreadcrump: (state, action: any) => {
      const newPaths: URLPath[] = Array.isArray(action.payload) ? action.payload : [action.payload];
      if (newPaths.length === 0) {
        return;
      }
      if (newPaths[0]?.reset) {
        state.urlPaths = newPaths;
        localStorage.setItem('breadcrumbs', JSON.stringify(newPaths));
        return;
      }
    
      const combinedPaths = [...state.urlPaths, ...newPaths];
      const lastPath = combinedPaths[combinedPaths.length - 1];
      const lastKey = lastPath.key;
    
      const extractBaseRoute = (key: string) => key.split('/')[1];
    
      const currentBaseRoute = extractBaseRoute(state.urlPaths[0]?.key || '');
      const newBaseRoute = extractBaseRoute(lastKey);
    
      if (currentBaseRoute && currentBaseRoute !== newBaseRoute) {
        state.urlPaths = newPaths;
        localStorage.setItem('breadcrumbs', JSON.stringify(newPaths));
        return;
      }
    
      const lastIndex = combinedPaths.findIndex((path, index) => {
        return path.key === lastKey && index !== combinedPaths.length - 1;
      });
    
      if (lastIndex !== -1) {
        state.urlPaths = combinedPaths.slice(0, lastIndex + 1);
        localStorage.setItem('breadcrumbs', JSON.stringify(combinedPaths.slice(0, lastIndex + 1)));
      } else {
        state.urlPaths = combinedPaths;
        localStorage.setItem('breadcrumbs', JSON.stringify(combinedPaths));
      }
    },

    resetOrganizationManagement: (state) => {
      state.organizationList = [];
      state.parentDetails = [];
      state.organizationData = {};
    },
    setOrganizationSetting: (state, action) => {
      state.organizationSetting = action.payload;
    },
    setOrganizationPermission: (state, action) => {
      state.organizationPermission = action.payload;
    },
    setOrganizationDetails: (state, action) => {
      state.organizationDetails = action.payload;
    }
  }
});

export const {
  setOrganizationList,
  setParentDetails,
  setIndividualOrganizationData,
  setLoggedInOrganization,
  setURLPaths,
  setBreadcrump,
  resetOrganizationManagement,
  setOrganizationSetting,
  setOrganizationDetails
} = organizationSlice.actions;

export default organizationSlice.reducer;
